import React from 'react';
import { useIntl } from 'react-intl';
import { useT } from '@transifex/react';
import useResponsiveText from 'hooks/useResponsiveText';
import { BankProduct } from 'types';
import {
  formatDefaultRate,
  formatPromotedProductTerm,
} from '../../../../utils/bankPageUtils/bankOffers';
import { getMarketingProductType } from '../../../../utils/getMarketingProductType';
import messages from '../../../Banks/messages';
import { productTypeMessages } from '../../BankDetails/BankOffersList/v2/BankOffersListItem';
import * as S from './styles';

export interface BankPromotedProductProps {
  product: BankProduct;
}

const BankPromotedProduct: React.FC<BankPromotedProductProps> = ({ product }) => {
  const t = useT();
  const intl = useIntl();
  const { formatNumber, locale } = intl;
  const marketedProductType = getMarketingProductType(product);
  const secondRowProductsData = {
    TERM: {
      label: t(messages.bankOffersListItemDuration),
      value: formatPromotedProductTerm(product, intl, t),
    },
    NOTICE: {
      label: t(messages.promotedProductNoticeHeadline),
      value: formatPromotedProductTerm(product, intl, t),
    },
    OVERNIGHT: {
      label: t(messages.bankOffersListItemDuration),
      value: formatPromotedProductTerm(product, intl, t),
    },
  };
  const isLongText = useResponsiveText([
    t(messages.bankOffersListItemRate),
    formatDefaultRate(product, locale, formatNumber, t),
    secondRowProductsData[marketedProductType]?.label,
    secondRowProductsData[marketedProductType]?.value,
    t(messages.bankOffersListItemProductType),
    t(productTypeMessages[marketedProductType]),
  ]);

  return (
    <S.Container>
      <S.ProductTopContainer data-element="best-offer-headline">
        <S.ProductTopText variant="body1">
          {t(messages.bankListPromotedProductHeadline)}
        </S.ProductTopText>
      </S.ProductTopContainer>
      <S.ProductContent>
        <S.ProductDetails data-element="best-offer-details">
          <S.Row>
            <S.RowTitle variant="subtitle2">{t(messages.bankOffersListItemRate)}</S.RowTitle>
            <S.RowData variant="subtitle1">
              {formatDefaultRate(product, locale, formatNumber, t)}
            </S.RowData>
          </S.Row>
          {marketedProductType !== 'OVERNIGHT' && (
            <S.Row>
              <S.RowTitle variant="subtitle2">
                {secondRowProductsData[marketedProductType]?.label}
              </S.RowTitle>
              <S.RowData variant="subtitle1">
                {secondRowProductsData[marketedProductType]?.value}
              </S.RowData>
            </S.Row>
          )}

          <S.ProductItem $isLongText={isLongText}>
            <S.RowTitle variant="subtitle2">{t(messages.bankOffersListItemProductType)}</S.RowTitle>
            <S.ProductTypeChip
              className={marketedProductType?.toLowerCase()}
              label={t(productTypeMessages[marketedProductType])}
            />
          </S.ProductItem>
        </S.ProductDetails>

        <S.ProductItemRow $isLongText={isLongText}>
          <S.ProductTypeChip
            className={marketedProductType?.toLowerCase()}
            label={t(productTypeMessages[marketedProductType])}
          />
        </S.ProductItemRow>
      </S.ProductContent>
    </S.Container>
  );
};

export default BankPromotedProduct;
